import React from 'react'
import { FormattedMessage } from 'react-intl'

export const NAME_BY_DIRECTION_SHORT = {
    A: (
        <FormattedMessage
            id='postbattle_screen_subtitle.battle.direction_a_short'
            defaultMessage={'С'}
        />
    ),
    B: (
        <FormattedMessage
            id='postbattle_screen_subtitle.battle.direction_b_short'
            defaultMessage={'В'}
        />
    ),
    C: (
        <FormattedMessage
            id='postbattle_screen_subtitle.battle.direction_c_short'
            defaultMessage={'Ю'}
        />
    ),
    D: (
        <FormattedMessage
            id='postbattle_screen_subtitle.battle.direction_d_short'
            defaultMessage={'З'}
        />
    ),
}


// WEBPACK FOOTER //
// ./components/BattleWizard/components/Direction/translations.jsx